import { CalendarDays } from "lucide-react";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  etichetaBilant,
  formatDataCompleta,
} from "@/utils/surseDateFormatting";
import type { AnBilant, SurseDateBilant } from "@/types/identificareFirma";

type AnBilantSelectorProps = {
  ani: AnBilant[];
  anSelectat: number | null;
  sursa: SurseDateBilant | null;
  onChange: (an: number) => void;
};

function AnBilantSelector({
  ani,
  anSelectat,
  sursa,
  onChange,
}: AnBilantSelectorProps) {
  const anCurent = ani.find((element) => element.an === anSelectat) ?? null;
  const curs = anCurent?.curs;

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-ds-border-200 bg-ds-surface-50 p-3 md:flex-row md:items-center md:justify-between">
      <div className="flex items-start gap-2">
        <CalendarDays className="h-4 w-4 mt-0.5 shrink-0 text-ds-text-400" />
        <div className="space-y-0.5">
          <p className="text-xs md:text-sm text-ds-text-600">
            {etichetaBilant(sursa)}
          </p>
          {curs && (
            <p className="text-xs text-ds-text-400">
              Curs BNR {formatDataCompleta(curs.data)}: {curs.curs}
            </p>
          )}
        </div>
      </div>

      {ani.length > 1 && (
        <div className="flex items-center gap-2">
          <Label className="text-xs whitespace-nowrap">Anul bilanțului</Label>
          <Select
            value={anSelectat !== null ? String(anSelectat) : ""}
            onValueChange={(valoare) => onChange(Number(valoare))}
          >
            <SelectTrigger className="h-8 w-28 text-xs">
              <SelectValue placeholder="An" />
            </SelectTrigger>
            <SelectContent>
              {ani.map((element) => (
                <SelectItem key={element.an} value={String(element.an)}>
                  {element.an}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      )}
    </div>
  );
}

export default AnBilantSelector;
